import axios from 'axios'
import _ from 'lodash'
// use retry-axios if we want to consider retries

export default (headers, config) => {
  const apiInstance = axios.create({
    // method: 'get', // default

    // `baseURL` will be prepended to `url` unless `url` is absolute.
    // It can be convenient to set `baseURL` for an instance of axios to pass relative URLs
    // to methods of that instance.
    baseURL: process.env.API_ENDPOINT
      ? _.trimEnd(process.env.API_ENDPOINT, '/')
      : '/',

    // `headers` are custom headers to be sent
    headers: {
      Accept: 'application/json',
      'Content-Type': _.has(headers, 'Content-Type')
        ? headers['Content-Type']
        : 'application/json',
      ...headers
      // 'X-Requested-With': 'XMLHttpRequest',
    },

    responseType: config.responseType,
    onUploadProgress: config.onUploadProgress,
    onDownloadProgress: config.onDownloadProgress,

    // `timeout` specifies the number of milliseconds before the request times out.
    // If the request takes longer than `timeout`, the request will be aborted.
    timeout: config.timeout, // default is `0` (no timeout)

    // `withCredentials` indicates whether or not cross-site Access-Control requests
    // should be made using credentials
    withCredentials: false, // default

    // `xsrfCookieName` is the name of the cookie to use as a value for xsrf token
    xsrfCookieName: 'XSRF-TOKEN', // default

    // `xsrfHeaderName` is the name of the http header that carries the xsrf token value
    xsrfHeaderName: 'X-XSRF-TOKEN' // default

    // `data` is the data to be sent as the request body
    // Only applicable for request methods 'PUT', 'POST', and 'PATCH'
    // When no `transformRequest` is set, must be of one of the following types:
    // - string, plain object, ArrayBuffer, ArrayBufferView, URLSearchParams
    // - Browser only: FormData, File, Blob
    // - Node only: Stream, Buffer
    // data: postBody

    // TODO: create standard error handling
  })

  // Add a request interceptor
  apiInstance.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      return config
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error)
    }
  )

  // Add a response interceptor
  apiInstance.interceptors.response.use(
    function (response) {
      return response

      // Do something with response data
      // {
      //   // `data` is the response that was provided by the server
      //   data: { },

      //   // `status` is the HTTP status code from the server response
      //   status: 200,

      //     // `statusText` is the HTTP status message from the server response
      //     statusText: 'OK',

      //       // `headers` the headers that the server responded with
      //       // All header names are lower cased
      //       headers: { },

      //   // `config` is the config that was provided to `axios` for the request
      //   config: { },

      //   // `request` is the request that generated this response
      //   // It is the last ClientRequest instance in node.js (in redirects)
      //   // and an XMLHttpRequest instance the browser
      //   request: { }
      // }
    },
    function (error) {
      // if user is unauthorized (token expired), then logout
      if (
        error.response &&
        error.response.status === 401 &&
        error.config &&
        !error.config.__isRetryRequest
      ) {
        // if you ever get an unauthorized, logout the user
        window.location.hash = '#/logout'
        window.location.reload()
      } else if (error.response) {
        throw error.response
      }
      throw error
    }
  )

  return apiInstance
}



// WEBPACK FOOTER //
// ./src/api/api-client.js